class AccountingSessionBatchItem {
  constructor() {
    this.SessionId = null;
    this.OriginalPrice = null;
    this.Discount = null;
    this.FinalPrice = null;
    this.TherapistId = null;
  }
}
export default AccountingSessionBatchItem;